<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    /** Надзаголовок (eyebrow). */
    eyebrow?: string;
    /** Заголовок секции. */
    title: string;
    /** Вводный текст под заголовком. */
    lead?: string;
    /** HTML-тег заголовка (h1/h2/h3). */
    as?: 'h1' | 'h2' | 'h3';
  }>(),
  { as: 'h2' },
);

const HeadingTag = computed(() => props.as);
</script>

<template>
  <span v-if="eyebrow" class="eyebrow">{{ eyebrow }}</span>
  <component :is="HeadingTag" class="section-title">{{ title }}</component>
  <p v-if="lead" class="section-lead">{{ lead }}</p>
</template>
